
import { DataDisplayComponents } from "@/Components/DataDisplayCompoants";
import { FeedbackNotificationComponents } from "@/Components/FeedbackNotificationComponats";
import { FormsComponents } from "@/Components/FormsComponents";
import { LayoutComponents } from "@/Components/LayoutComponents";
import { NavigationComponents } from "@/Components/NavigationComponents";
import React from "react";

const ComponentsPage = () => {
  return (
    <div className="container mx-auto p-4">
      <p><b>Components</b></p>
      <div className="space-y-4">
        <NavigationComponents />
        <DataDisplayComponents />
        <LayoutComponents />
        <FormsComponents />
        <FeedbackNotificationComponents />
      </div>
    </div>
  );
};

export default ComponentsPage;

